module.exports = __webpack_public_path__ + "static/media/guide_3.6aa4cc29.svg";